import { render } from "./PresalesSubmissions.vue?vue&type=template&id=36e9efe7&scoped=true"
import script from "./PresalesSubmissions.vue?vue&type=script&lang=js"
export * from "./PresalesSubmissions.vue?vue&type=script&lang=js"

import "./PresalesSubmissions.vue?vue&type=style&index=0&id=36e9efe7&scoped=true&lang=css"

import exportComponent from "/working_dir/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-36e9efe7"]])

export default __exports__